// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3W1Qy","footer":"ModalError_footer__34aDn"};